const TestimonialsData01 = [
    {
        name: 'SHOKO MUGIKURA',
        designation: 'GRAPHIC DESIGNER',
        content: 'Their team are easy to work with and helped me make amazing websites in a short amount of time. Thanks guys for all your hard work.',
        img: 'https://via.placeholder.com/125x125',
    },
    {
        name: 'JONSAN DONNER',
        designation: 'SALES MANAGER',
        content: 'Trust us we looked for a very long time and wasted thousands of dollars testing other teams, freelancers, and outsource companies.',
        img: 'https://via.placeholder.com/125x125'
    },
    {
        name: 'MACKANGY ROSE',
        designation: 'CREATIVE DIRECTOR',
        content: 'This is an excellent company! I personally enjoyed the energy and the professional support the whole team gave to us into creating website.',
        img: 'https://via.placeholder.com/125x125'
    }
]

const TestimonialsData02 = [
    {
        name: 'JEREMY SMITH',
        designation: 'CO FOUNDER',
        content: 'Lorem ipsum dolor amet consectetur do eiusmod tempor incididunt labore ut enim ad minim veniam',
        img: 'https://via.placeholder.com/800x580'
    },
    {
        name: 'SHOKO MUGIKURA',
        designation: 'CREATIVE HEAD',
        content: 'Lorem ipsum dolor amet consectetur do eiusmod tempor incididunt labore ut enim ad minim veniam',
        img: 'https://via.placeholder.com/800x580'
    },
    {
        name: 'HERMAN MILLER',
        designation: 'HR MANAGER',
        content: 'Lorem ipsum dolor amet consectetur do eiusmod tempor incididunt labore ut enim ad minim veniam',
        img: 'https://via.placeholder.com/800x580'
    }
]

const TestimonialsData03 = [
    {
        name: 'Herman Miller',
        designation: 'ThemeZaa Design',
        content: 'Lorem ipsum dolor amet consectetur do tempor incididunt labore et dolore magna nostrud exercitation ullamco.',
        img: 'https://via.placeholder.com/125x125',
    },
    {
        name: 'Jeremy Girard',
        designation: 'Microsoft Corporation',
        content: 'Lorem ipsum dolor amet consectetur do tempor incididunt labore et dolore magna nostrud exercitation ullamco.',
        img: 'https://via.placeholder.com/125x125'
    },
    {
        name: 'Alexander Harvard',
        designation: 'ThemeZaa Design',
        content: 'Lorem ipsum dolor amet consectetur do tempor incididunt labore et dolore magna nostrud exercitation ullamco.',
        img: 'https://via.placeholder.com/125x125'
    }
]

const TestimonialsData04 = [
    {
        name: 'Herman Miller',
        content: 'Lorem ipsum dolor amet consectetur do tempor incididunt labore et dolore magna nostrud exercitation ullamco.',
        img: 'https://via.placeholder.com/125x125',
        rating:5
    },
    {
        name: 'Jeremy Girard',
        content: 'Lorem ipsum dolor amet consectetur do tempor incididunt labore et dolore magna nostrud exercitation ullamco.',
        img: 'https://via.placeholder.com/125x125',
        rating:5
    },
    {
        name: 'Alexander Harvard',
        content: 'Lorem ipsum dolor amet consectetur do tempor incididunt labore et dolore magna nostrud exercitation ullamco.',
        img: 'https://via.placeholder.com/125x125',
        rating:5
    }
]

const TestimonialsData05 = [
    {
        name: 'Herman Miller',
        content: 'Simply superb resort. Management and staff deserve special appreciation and thanks for hospitality.',
        img: 'https://via.placeholder.com/125x125',
        rating:5
    },
    {
        name: 'Loretta Smith',
        content: 'We are back home now and feel that it is only right to write to you to express our warmest gratitude.',
        img: 'https://via.placeholder.com/125x125',
        rating:5
    },
    {
        name: 'Jeremy Girard',
        content: 'Wonderful place to live for holidays. Can’t believe can have such beautiful environment to spend peaceful.',
        img: 'https://via.placeholder.com/125x125',
        rating:5
    }
]

export { TestimonialsData01, TestimonialsData02, TestimonialsData03, TestimonialsData04, TestimonialsData05 }